'use client';
import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';


const ScaleChip = ({label, deletable = false, onDelete, onClick}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async (e) => {
    e.stopPropagation();
    setIsDeleting(true);
    try {
      await onDelete();
    } catch (error) {
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      {  deletable && (
        <div className={`btn btn-ghost group ${isDeleting ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(label);
          }}>
          {label}
          <XMarkIcon className={`invisible group-hover:visible w-4 h-4 inline text-orange-600 ${isDeleting ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={handleDelete}/>
        </div>
      )}

      { !deletable && (
        <div className="btn btn-ghost" onClick={(e) => {
          e.stopPropagation();
          onClick?.(label);
        }}>
          {label}
        </div>
      )}
    </>
  );
};

export default ScaleChip;
